import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const PrivateRoute = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  // While the store is rehydrating from localStorage, user might be null briefly.
  // We can add a loading state here if needed, but for now, this is robust.

  if (!user || !['SUPERADMIN', 'ADMIN', 'STAFF'].includes(user.rank?.name)) {
    // If there is no user, or the user is not an admin or super admin, redirect to the login page.
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
